<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="footer-main-left">
        <router-link class="footer-logo-link" to="/">
          <img class="footer-logo" src="/logo_white.svg" />
        </router-link>

        <router-link class="footer-main-link" to="/tos">
          {{ $t('footer.tos') }}
        </router-link>
        <router-link class="footer-main-link" to="/privacy">
          {{ $t('footer.privacyPolicy') }}
        </router-link>
        <a class="footer-main-link" :href="TELEGRAM_SUPPORT" target="_blank">
          {{ $t('footer.report') }}
        </a>
      </div>

      <div class="footer-main-right">
        <a class="footer-contact" :href="TELEGRAM_SUPPORT" target="_blank">
          <img src="~@/assets/icons/telegram-blue.svg" />
          <p class="footer-contact-txt">{{ $t('footer.contact') }}</p>
        </a>

        <a
          class="footer-extension"
          href="https://chrome.google.com/webstore/detail/metrica-extension/egbpanhlmgjioikbjgaiihfkpkfafapg"
          target="_blank"
        >
          <img class="footer-extension-icon" src="/extension.png" />
          <p class="footer-extension-title">{{ $t('footer.install') }}</p>
          <p class="footer-extension-desc">{{ $t('footer.extension') }}</p>
        </a>

        <a
          class="footer-extension"
          href="https://addons.mozilla.org/en-US/firefox/addon/metrica/"
          target="_blank"
        >
          <img class="footer-extension-icon" src="~@/assets/icons/firefox.svg" />
          <p class="footer-extension-title">{{ $t('footer.install') }}</p>
          <p class="footer-extension-desc">{{ $t('footer.extension') }}</p>
        </a>
      </div>
    </div>

  </footer>
</template>

<script>
import { TELEGRAM_SUPPORT } from '@/helpers/variables'

export default {
  computed: {
    TELEGRAM_SUPPORT: () => TELEGRAM_SUPPORT,
  },
}
</script>

<style scoped>
.footer {
  background: var(--sidebar-bg);
  color: var(--text-secondary3);
  position: relative;
}

.footer-main {
  margin: 25px 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-main-left {
  display: flex;
  gap: 40px;
  align-items: center;
}

/* до 1600px логотип с тремя ссылками и правый блок не помещаются в одну строку:
   ссылки занимают свою строку, контакты и расширения уходят под них */
@media (min-width: 1025px) and (max-width: 1600px) {
  .footer-main {
    flex-wrap: wrap;
    row-gap: 24px;
  }
  .footer-main-left {
    width: 100%;
  }
}

.footer-logo {
  width: 160px;
}

.footer-main-link {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  white-space: nowrap;
}

.footer-main-right {
  display: grid;
  grid-auto-flow: column;
  gap: 50px;
  align-items: center;
}

.footer-contact {
  display: grid;
  grid-auto-flow: column;
  gap: 16px;
  align-items: center;
  color: #ffffff;
}

.footer-contact-txt {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}

.footer-extension {
  padding: 10px 15px;
  background-color: transparent;
  border-radius: 7px;
  display: grid;
  grid-template: 'icon title' 'icon desc';
  align-items: center;
  column-gap: 15px;
  background-color: rgba(255, 255, 255, 0.07);
  transition: all 200ms ease;
}

.footer-extension:hover {
  background-color: rgba(255, 255, 255, 0.15);
  text-decoration: none;
}

.footer-extension-icon {
  grid-area: icon;
}

.footer-extension-title {
  margin: 0;
  grid-area: title;
  font-weight: bold;
  font-size: 19px;
  line-height: 24px;
  color: #ffffff;
}

.footer-extension-desc {
  margin: 0;
  grid-area: desc;
  font-size: 11px;
  line-height: 14px;
  color: #ffffff;
}

.footer-extension-icon {
  width: 29px;
  height: 29px;
}

.footer-extra {
  padding: 20px 60px;
  border-top: 1px solid var(--sidebar-divider);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-copy {
  margin: 0;
  font-size: 14px;
  line-height: 19px;
  color: var(--text-secondary2);
}

.footer-links {
  display: grid;
  grid-auto-flow: column;
  gap: 40px;
}

.footer-link {
  font-size: 14px;
  line-height: 19px;
  color: var(--text-secondary2);
}

@media (max-width: 1024px) {
  .footer-copy,
  .footer-extension {
    display: none;
  }

  .footer-main {
    margin: 20px;
    flex-direction: column;
    align-items: center;
  }

  .footer-logo-link {
    display: none;
  }

  /* ссылки в столбик по центру: в строку они не помещаются и уезжают за экран */
  .footer-main-left {
    display: grid;
    grid-auto-flow: row;
    gap: 14px;
    width: 100%;
    justify-items: center;
  }

  .footer-main-link {
    font-size: 14px;
    text-align: center;
  }

  .footer-main-right {
    margin-top: 15px;
    justify-content: center;
  }

  .footer-links {
    grid-auto-flow: row;
    gap: 15px;
    text-align: center;
    width: 100%;
  }
}
</style>
